import { render, staticRenderFns } from "./WeForest.vue?vue&type=template&id=8eb1bfbe&scoped=true&"
import script from "./WeForest.vue?vue&type=script&lang=js&"
export * from "./WeForest.vue?vue&type=script&lang=js&"
import style0 from "./WeForest.vue?vue&type=style&index=0&id=8eb1bfbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb1bfbe",
  null
  
)

component.options.__file = "WeForest.vue"
export default component.exports